<!-- ReportSources.vue - Complete Updated Component -->
<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Collection Sources Report</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Rental management system by Nouveta LTD" name="description" />
      <meta content="Kelvin Njuguna" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Bootstrap select styling -->
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Collection Sources Report</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item active">Collection Sources</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Security Credentials Alert -->
          <div v-if="showCredentialAlert" class="row mb-3">
            <div class="col-12">
              <div class="alert alert-dismissible fade show"
                   :class="credentialAlertStatus.alertClass"
                   role="alert">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-shield-alert-outline font-size-20 me-2"></i>
                  <div class="flex-grow-1">
                    <strong>{{credentialAlertStatus.title}}</strong>
                    <p class="mb-0">{{credentialAlertStatus.message}}</p>
                  </div>
                  <div class="btn-group ms-3" role="group">
                    <button type="button"
                            class="btn btn-sm"
                            :class="credentialAlertStatus.buttonClass"
                            @click="showUpdateCredentialsModal">
                      <i class="mdi mdi-refresh"></i> Update First Expired
                    </button>
                    <button type="button"
                            class="btn btn-sm btn-outline-primary"
                            @click="showCredentialSelectionModal">
                      <i class="mdi mdi-format-list-bulleted"></i> Select Source
                    </button>
                  </div>
                  <button type="button" class="btn-close ms-2" @click="showCredentialAlert = false"></button>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Collections</p>
                      <h4 class="mb-0">{{formatPrice(totalAmount)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Sources</p>
                      <h4 class="mb-0">{{activeSources}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                        <span class="avatar-title">
                          <i class="bx bx-check-circle font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">MPESA Sources</p>
                      <h4 class="mb-0">{{mpesaAmount}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-mobile font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Bank Sources</p>
                      <h4 class="mb-0">{{bankAmount}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-building font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">
                        <i class="bx bx-bar-chart-alt-2 me-2"></i>Collection Sources for {{displayDateRange}}
                      </h4>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <button @click="refreshData" class="btn btn-sm btn-outline-primary me-2" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                      <div class="btn-group" role="group">
                        <button @click="setDateRange('today')" class="btn btn-sm" :class="dateRangeType === 'today' ? 'btn-primary' : 'btn-outline-primary'">Today</button>
                        <button @click="setDateRange('week')" class="btn btn-sm" :class="dateRangeType === 'week' ? 'btn-primary' : 'btn-outline-primary'">This Week</button>
                        <button @click="setDateRange('month')" class="btn btn-sm" :class="dateRangeType === 'month' ? 'btn-primary' : 'btn-outline-primary'">This Month</button>
                        <button @click="setDateRange('custom')" class="btn btn-sm" :class="dateRangeType === 'custom' ? 'btn-primary' : 'btn-outline-primary'">Custom</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Filters Section -->
                  <div class="row mb-4">
                    <div class="col-md-3">
                      <label class="form-label">Search</label>
                      <div class="input-group">
                        <span class="input-group-text"><i class="bx bx-search"></i></span>
                        <input v-model="searchValue" class="form-control" placeholder="Search by name or code..." type="text">
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label class="form-label">Collection Type</label>
                      <select v-model="filterType" class="form-select">
                        <option value="">All Types</option>
                        <option value="MPESA">MPESA</option>
                        <option value="BANK">BANK</option>
                      </select>
                    </div>

                    <div class="col-md-3" v-if="dateRangeType === 'custom'">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" class="form-control" type="date" :max="dateTo">
                    </div>

                    <div class="col-md-3" v-if="dateRangeType === 'custom'">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" class="form-control" type="date" :min="dateFrom" :max="maxDate">
                    </div>

                    <div class="col-md-2" :class="dateRangeType === 'custom' ? '' : 'offset-md-3'">
                      <label class="form-label">Actions</label>
                      <div class="d-flex gap-2">
                        <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadToCSV()" class="btn btn-success btn-sm" :disabled="filteredCollections.length === 0">
                          <i class="mdi mdi-download"></i> CSV
                        </button>
                        <button v-if="mpesaSources.length > 1" @click="showCredentialSelectionModal" class="btn btn-warning btn-sm" title="Update MPESA Credentials">
                          <i class="mdi mdi-shield-refresh"></i> Update
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Table Section -->
                  <div class="table-responsive">
                    <table class="table table-hover table-striped align-middle">
                      <thead class="table-light">
                      <tr>
                        <th width="5%">#</th>
                        <th width="15%">
                            <span class="d-flex align-items-center">
                              Type
                              <i class="bx bx-sort-alt-2 ms-1 cursor-pointer" @click="sortBy('collectionType')"></i>
                            </span>
                        </th>
                        <th width="30%">
                            <span class="d-flex align-items-center">
                              Account Name
                              <i class="bx bx-sort-alt-2 ms-1 cursor-pointer" @click="sortBy('shortCodeName')"></i>
                            </span>
                        </th>
                        <th width="15%">Account Number</th>
                        <th width="15%" class="text-end">
                            <span class="d-flex align-items-center justify-content-end">
                              Amount Collected
                              <i class="bx bx-sort-alt-2 ms-1 cursor-pointer" @click="sortBy('amountCollected')"></i>
                            </span>
                        </th>
                        <th width="10%" class="text-center">Credential Status</th>
                        <th width="10%" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody v-if="!loading && filteredCollections.length > 0">
                      <tr v-for="(item, index) in paginatedCollections" :key="item.short_code"
                          :class="{'table-success': parseFloat(item.amountCollected) > 0}">
                        <td>{{(currentPage - 1) * itemsPerPage + index + 1}}</td>
                        <td>
                            <span class="badge" :class="item.collectionType === 'MPESA' ? 'bg-info' : 'bg-warning'">
                              {{item.collectionType}}
                            </span>
                        </td>
                        <td class="text-capitalize">
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                <span class="avatar-title rounded-circle"
                                      :class="item.collectionType === 'MPESA' ? 'bg-soft-info text-info' : 'bg-soft-warning text-warning'">
                                  <i :class="item.collectionType === 'MPESA' ? 'bx bx-mobile' : 'bx bx-building'"></i>
                                </span>
                            </div>
                            <div>
                              <h6 class="mb-0">{{item.shortCodeName}}</h6>
                              <small class="text-muted">{{item.collectionTypeName}}</small>
                            </div>
                          </div>
                        </td>
                        <td><code>{{item.short_code}}</code></td>
                        <td class="text-end">
                          <strong :class="parseFloat(item.amountCollected) > 0 ? 'text-success' : 'text-muted'">
                            {{formatPrice(item.amountCollected)}}
                          </strong>
                        </td>
                        <td class="text-center">
                          <span v-if="item.collectionType === 'MPESA'"
                                class="badge"
                                :class="getCredentialStatusBadge(item).class"
                                :title="getCredentialStatusBadge(item).tooltip">
                            {{getCredentialStatusBadge(item).text}}
                          </span>
                          <span v-else class="badge bg-secondary">N/A</span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group" role="group">
                            <button v-if="parseFloat(item.amountCollected) > 0"
                                    @click="viewTransactions(item)"
                                    class="btn btn-sm btn-soft-primary"
                                    title="View Transactions">
                              <i class="bx bx-list-ul"></i>
                            </button>
                            <button v-if="item.collectionType === 'MPESA' && getRight('UPDATE CREDENTIALS')"
                                    @click="editCredentials(item)"
                                    class="btn btn-sm btn-soft-warning"
                                    title="Update Credentials">
                              <i class="bx bx-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-else-if="loading">
                      <tr>
                        <td colspan="7" class="text-center py-5">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <p class="mt-3 mb-0">Loading collection sources...</p>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr>
                        <td colspan="7" class="text-center py-5">
                          <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 100px; opacity: 0.5;">
                          <p class="mt-3 mb-0 text-muted">No collection sources found for the selected criteria</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{(currentPage - 1) * itemsPerPage + 1}} to {{Math.min(currentPage * itemsPerPage, filteredCollections.length)}} of {{filteredCollections.length}} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{disabled: currentPage === 1}">
                            <a @click="currentPage > 1 && currentPage--" class="page-link">Previous</a>
                          </li>
                          <li v-for="page in displayedPages" :key="page"
                              class="paginate_button page-item"
                              :class="{active: page === currentPage, disabled: page === '...'}">
                            <a @click="page !== '...' && (currentPage = page)" class="page-link">{{page}}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{disabled: currentPage === totalPages}">
                            <a @click="currentPage < totalPages && currentPage++" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Summary Footer -->
                  <div class="row mt-4 pt-3 border-top">
                    <div class="col-md-6">
                      <h6 class="mb-0">Summary</h6>
                      <small class="text-muted">
                        Total Sources: {{filteredCollections.length}} |
                        Active: {{activeSources}} |
                        Inactive: {{filteredCollections.length - activeSources}}
                      </small>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <h5 class="mb-0 text-primary">Total: {{formatPrice(filteredTotal)}}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Powered by Birdy Billing System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- Collection Source Transactions Modal -->
    <CollectionSourceTransactions
        ref="transactionsModal"
        :sourceDetails="selectedSource"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
    />

    <!-- Update Credentials Modal -->
    <UpdateSecurityCredentials
        ref="updateCredentialsModal"
        :sourceDetails="selectedCredentialSource"
        @credentialsUpdated="onCredentialsUpdated"
    />

    <!-- Credential Selection Modal -->
    <CredentialSelectionModal
        ref="credentialSelectionModal"
        :sources="mpesaSources"
        @sourceSelected="editCredentials"
    />
    </body>

  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import CollectionSourceTransactions from "@/components/reports/sources/CollectionSourceTransactions.vue";
import UpdateSecurityCredentials from "@/components/reports/sources/UpdateSecurityCredentials.vue";
import CredentialSelectionModal from "@/components/reports/sources/CredentialSelectionModal.vue";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "ReportSources",
  components: {NavigationBar, CollectionSourceTransactions, UpdateSecurityCredentials, CredentialSelectionModal},

  data() {
    return{
      totalAmount: 0,
      download: 'Download CSV',
      loading: false,
      dateFrom: '',
      dateTo: '',
      maxDate: moment().format('YYYY-MM-DD'),
      searchValue: "",
      filterType: "",
      dateRangeType: 'month',
      sortColumn: '',
      sortDirection: 'asc',
      currentPage: 1,
      itemsPerPage: 50,
      selectedSource: {},
      selectedCredentialSource: {},
      showCredentialAlert: true,
      credentialAlertStatus: {
        title: '',
        message: '',
        alertClass: '',
        buttonClass: ''
      },
      collections: [{
        collectionType: "",
        shortCodeName: "",
        collectionTypeName: "",
        short_code: "",
        amountCollected: "",
        security_credential: "",
        initiator: "",
        date: ""
      }],
      monthNames: ['','January','February','March','April','May','June','July','August','September','October','November','December'],
      monthName: '',
      month: ''
    }
  },
  computed: {
    filteredCollections() {
      let filtered = this.collections;

      // Search filter
      if (this.searchValue) {
        const search = this.searchValue.toLowerCase();
        filtered = filtered.filter(item =>
            item.shortCodeName.toLowerCase().includes(search) ||
            item.short_code.toLowerCase().includes(search)
        );
      }

      // Type filter
      if (this.filterType) {
        filtered = filtered.filter(item => item.collectionType === this.filterType);
      }

      // Sort
      if (this.sortColumn) {
        filtered = [...filtered].sort((a, b) => {
          let aVal = a[this.sortColumn];
          let bVal = b[this.sortColumn];

          if (this.sortColumn === 'amountCollected') {
            aVal = parseFloat(aVal) || 0;
            bVal = parseFloat(bVal) || 0;
          }

          if (this.sortDirection === 'asc') {
            return aVal > bVal ? 1 : -1;
          } else {
            return aVal < bVal ? 1 : -1;
          }
        });
      }

      return filtered;
    },

    paginatedCollections() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCollections.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredCollections.length / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    },

    activeSources() {
      return this.collections.filter(item => parseFloat(item.amountCollected) > 0).length;
    },

    mpesaSources() {
      return this.collections.filter(item => item.collectionType === 'MPESA');
    },

    mpesaAmount() {
      const total = this.collections
          .filter(item => item.collectionType === 'MPESA')
          .reduce((sum, item) => sum + parseFloat(item.amountCollected || 0), 0);
      return this.formatPrice(total);
    },

    bankAmount() {
      const total = this.collections
          .filter(item => item.collectionType === 'BANK')
          .reduce((sum, item) => sum + parseFloat(item.amountCollected || 0), 0);
      return this.formatPrice(total);
    },

    filteredTotal() {
      return this.filteredCollections.reduce((sum, item) => sum + parseFloat(item.amountCollected || 0), 0);
    },

    displayDateRange() {
      if (this.dateRangeType === 'today') {
        return moment().format('MMMM D, YYYY');
      } else if (this.dateRangeType === 'week') {
        return `${moment().startOf('week').format('MMM D')} - ${moment().endOf('week').format('MMM D, YYYY')}`;
      } else if (this.dateRangeType === 'month') {
        return moment().format('MMMM YYYY');
      } else {
        return `${moment(this.dateFrom).format('MMM D')} - ${moment(this.dateTo).format('MMM D, YYYY')}`;
      }
    }
  },
  mounted() {
    // Set initial date range to current month
    this.setDateRange('month');
    this.getTransactions();

    // Watch for filter changes
    this.$watch('searchValue', () => this.currentPage = 1);
    this.$watch('filterType', () => this.currentPage = 1);
    this.$watch('dateFrom', function(newValue) {
      if(this.dateFrom && this.dateTo && this.dateRangeType === 'custom') {
        this.getTransactions();
      }
    });
    this.$watch('dateTo', function(newValue) {
      if(this.dateFrom && this.dateTo && this.dateRangeType === 'custom') {
        this.getTransactions();
      }
    });

    const d = new Date();
    this.month = d.getMonth() + 1;
    this.monthName = this.getCurrentMonth() + " " + this.getCurrentYear();

    this.menuAccess();
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Collection Sources");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    checkCredentialStatus() {
      // Check MPESA sources for credential expiration
      const mpesaSources = this.collections.filter(item => item.collectionType === 'MPESA');

      if (mpesaSources.length === 0) {
        this.showCredentialAlert = false;
        return;
      }

      let hasExpired = false;
      let hasExpiringSoon = false;
      let daysUntilExpiry = 30;
      let expiredCount = 0;
      let expiringSoonCount = 0;

      mpesaSources.forEach(source => {
        if (source.date) {
          const lastUpdate = moment(source.date);
          const daysSinceUpdate = moment().diff(lastUpdate, 'days');
          const remaining = 30 - daysSinceUpdate;

          if (remaining <= 0) {
            hasExpired = true;
            expiredCount++;
          } else if (remaining <= 7) {
            hasExpiringSoon = true;
            expiringSoonCount++;
          }

          if (remaining < daysUntilExpiry) {
            daysUntilExpiry = remaining;
          }
        } else {
          // No update date means it's never been updated
          hasExpired = true;
          expiredCount++;
          daysUntilExpiry = 0;
        }
      });

      // Set alert status
      if (hasExpired) {
        this.credentialAlertStatus = {
          title: 'Security Credentials Expired!',
          message: `${expiredCount} MPESA ${expiredCount === 1 ? 'source has' : 'sources have'} expired credentials and need immediate update.`,
          alertClass: 'alert-danger',
          buttonClass: 'btn-danger'
        };
        this.showCredentialAlert = true;
      } else if (hasExpiringSoon) {
        this.credentialAlertStatus = {
          title: 'Security Credentials Expiring Soon',
          message: `${expiringSoonCount} MPESA ${expiringSoonCount === 1 ? 'source has' : 'sources have'} credentials expiring within 7 days. Please update them to ensure continuous service.`,
          alertClass: 'alert-warning',
          buttonClass: 'btn-warning'
        };
        this.showCredentialAlert = true;
      } else if (daysUntilExpiry < 15) {
        this.credentialAlertStatus = {
          title: 'Security Credentials Status',
          message: `Credentials are valid. Next expiry in ${daysUntilExpiry} days.`,
          alertClass: 'alert-info',
          buttonClass: 'btn-info'
        };
        this.showCredentialAlert = true;
      } else {
        this.showCredentialAlert = false;
      }
    },

    getCredentialStatusBadge(item) {
      if (item.collectionType !== 'MPESA') {
        return { text: 'N/A', class: 'bg-secondary', tooltip: 'Not applicable for bank sources' };
      }

      if (!item.date) {
        return { text: 'Never Updated', class: 'bg-danger', tooltip: 'Credentials have never been updated' };
      }

      const lastUpdate = moment(item.date);
      const daysSinceUpdate = moment().diff(lastUpdate, 'days');
      const daysRemaining = 30 - daysSinceUpdate;

      if (daysRemaining <= 0) {
        return {
          text: 'Expired',
          class: 'bg-danger',
          tooltip: `Expired ${Math.abs(daysRemaining)} days ago on ${lastUpdate.clone().add(30, 'days').format('MMM D, YYYY')}`
        };
      } else if (daysRemaining <= 7) {
        return {
          text: `${daysRemaining} days left`,
          class: 'bg-warning',
          tooltip: `Expires on ${lastUpdate.clone().add(30, 'days').format('MMM D, YYYY')}`
        };
      } else if (daysRemaining <= 15) {
        return {
          text: `${daysRemaining} days left`,
          class: 'bg-info',
          tooltip: `Expires on ${lastUpdate.clone().add(30, 'days').format('MMM D, YYYY')}`
        };
      } else {
        return {
          text: 'Active',
          class: 'bg-success',
          tooltip: `${daysRemaining} days remaining. Expires on ${lastUpdate.clone().add(30, 'days').format('MMM D, YYYY')}`
        };
      }
    },

    setDateRange(type) {
      this.dateRangeType = type;
      const now = moment();

      switch(type) {
        case 'today':
          this.dateFrom = now.format('YYYY-MM-DD');
          this.dateTo = now.format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateFrom = now.startOf('week').format('YYYY-MM-DD');
          this.dateTo = now.endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateFrom = now.startOf('month').format('YYYY-MM-DD');
          this.dateTo = now.clone().endOf('month').format('YYYY-MM-DD');
          break;
      }

      if (type !== 'custom') {
        this.getTransactions();
      }
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },

    refreshData() {
      this.getTransactions();
    },

    downloadToCSV() {
      if (this.filteredCollections.length === 0) {
        alert('No data to download');
        return;
      }

      this.download = 'Generating...';

      // Prepare CSV content
      const headers = ['#', 'Collection Type', 'Account Name', 'Account Number', 'Amount Collected', 'Credential Status', 'Last Updated'];
      const csvContent = [
        headers.join(','),
        ...this.filteredCollections.map((item, index) => {
          const status = item.collectionType === 'MPESA' ? this.getCredentialStatusBadge(item).text : 'N/A';
          const lastUpdated = item.date ? moment(item.date).format('MMM D, YYYY') : 'Never';
          return [
            index + 1,
            item.collectionType,
            `"${item.shortCodeName}"`, // Wrap in quotes to handle commas
            item.short_code,
            item.amountCollected,
            status,
            lastUpdated
          ].join(',');
        })
      ].join('\n');

      // Add summary at the end
      const summaryContent = `\n\nSummary\nDate Range:,${this.displayDateRange}\nTotal Sources:,${this.filteredCollections.length}\nActive Sources:,${this.activeSources}\nTotal Amount:,${this.filteredTotal}`;

      // Create blob and download
      const blob = new Blob([csvContent + summaryContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `collection_sources_${this.dateFrom}_to_${this.dateTo}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.download = 'Download CSV';
    },

    getTransactions() {
      this.collections.splice(0);
      this.loading = true;

      const data = new FormData();
      data.append("function", "getCollectionSources");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute2(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.collections = res.data.data.list;

              // Calculate the total amount
              this.totalAmount = this.collections.reduce((sum, item) => {
                const amount = parseFloat(item.amountCollected);
                return sum + (isNaN(amount) ? 0 : amount);
              }, 0);

              // Check credential status after loading data
              this.checkCredentialStatus();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    viewTransactions(source) {
      this.selectedSource = source;
      this.$nextTick(() => {
        this.$refs.transactionsModal.show();
      });
    },

    editCredentials(source) {
      this.selectedCredentialSource = source;
      this.$nextTick(() => {
        this.$refs.updateCredentialsModal.show();
      });
    },

    showUpdateCredentialsModal() {
      // Show modal for first MPESA source that needs update
      const mpesaSource = this.collections.find(item => {
        if (item.collectionType !== 'MPESA') return false;

        if (!item.date) return true; // Never updated

        const lastUpdate = moment(item.date);
        const daysSinceUpdate = moment().diff(lastUpdate, 'days');
        return daysSinceUpdate > 23; // Needs update soon or expired
      });

      if (mpesaSource) {
        this.editCredentials(mpesaSource);
      } else {
        // If no source needs immediate update, show the first MPESA source
        const firstMpesa = this.collections.find(item => item.collectionType === 'MPESA');
        if (firstMpesa) {
          this.editCredentials(firstMpesa);
        }
      }
    },

    showCredentialSelectionModal() {
      this.$nextTick(() => {
        this.$refs.credentialSelectionModal.show();
      });
    },

    onCredentialsUpdated() {
      // Refresh data after credentials update
      this.getTransactions();

      // Show success message using toast if available, otherwise alert
      if (this.$toast) {
        this.$toast.success('Security credentials updated successfully!');
      } else {
        alert('Security credentials updated successfully!');
      }
    },

    getCurrentMonth() {
      const d = new Date();
      const monthName = this.monthNames[d.getMonth() + 1];
      return monthName;
    },

    getCurrentYear() {
      const date = new Date();
      return date.getFullYear();
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-info {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 106, 106, 0.1);
}

.table-success {
  background-color: rgba(34, 184, 121, 0.05) !important;
}

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
  border-color: transparent;
}

.btn-soft-primary:hover {
  color: #fff;
  background-color: #556ee6;
  border-color: #556ee6;
}

.btn-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.1);
  border-color: transparent;
}

.btn-soft-warning:hover {
  color: #fff;
  background-color: #f1b44c;
  border-color: #f1b44c;
}
</style>